module.exports = __webpack_public_path__ + "img/file----837@1x.a63eb9ce.png";